<template>
  <section class="cont__contact">
    <p>Let's create something new</p>
    <h3>LET'S Get IN <em>TOUBH</em></h3>
    <a href="mailto:leesh3432@naver.com">Contact me</a>
  </section>
</template>
